const c = {
    darkBlue: "#1C2F5E",
    blue: "#1269B0",
    lightBlue: "#EAEEF9",
    deepRed: "#771E24",
    deepOrange: "#CC5500",
    green: "#1BA348",
    biscay: "#1C2F5E"
};
const main = {
    primary: c.darkBlue,
    "primary-light": c.lightBlue,
    secondary: c.deepRed,
    tertiary: c.lightBlue,
    accent: c.blue,
    alert: "#fce5e5",
    error: "#FF8A65",
    warning: "#f8a428",
    info: c.lightBlue,
    success: c.lightBlue,
    valid: c.green,
    muted: "#9b9b9b",
    strong: "#f6f6f6",
    alternate: "#f0f3fa",
    edit: c.deepOrange,
    "edit-green": c.green,
    remove: "#d0021b",
    stats: c.deepOrange,
    star: "#eec216",
    background: "#FFFFFF"
};
const customColors = {
    rose: "#ab539f",
    orange: c.deepOrange,
    green: c.green,
    biscay: c.biscay,
    white: "#FFF",
    "light-grey": "#fbfbfb"
};
const specificAreas = {
    mainMenuText: c.biscay,
    mainMenuTextActive: c.deepRed,
    eventResultsBtn: c.green,
    footer: c.darkBlue,
    accessability: "#ffff02"
};
const eventStatuses = {
    draft: "#000000",
    cancelled: "#FF0000",
    proposed: "#dc5727",
    declined: "#000000",
    published: "#1BA348",
    schedule_proposed: "#dc5727",
    schedule_declined: "#dc5727",
    registration_open: "#000000",
    registration_closed: "#000000",
    event_running: "#FF0000",
    event_ended: "#dc5727",
    results_published: "#1BA348",
    closed: "#000000",
    discarded: "#000000",
    unknown: "#000000"
};
const disciplines = {
    western: "#bf9372",
    showjumping: "#256fb6",
    icelandic: "#ab539f",
    vaulting: "#2cd4c3",
    endurance: "#dc5727",
    driving: "#fab624",
    paradriving: "#fab624",
    dressage: "#7c878e",
    paradressage: "#7c878e",
    eventing: "#3aaf6c",
    mountedgames: "#6859AC"
};
export default {
    light: {
        ...main,
        ...customColors,
        ...eventStatuses,
        ...disciplines,
        ...specificAreas
    },
    dark: {
        ...main,
        ...customColors,
        ...eventStatuses,
        ...disciplines,
        ...specificAreas
    }
};
export const quillColors = [
    main.primary,
    main.alternate,
    main.accent,
    c.deepRed,
    "black"
];
